<template>
  <div
    class="radio-item"
    :class="{ 'radio-item-active': value == checked }"
    @click="bindCheck"
  >
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: String | Number,
      default: ''
    }
  },
  data() {
    return {
      checked: false
    }
  },
  created() {
    this.$parent && this.$parent.updateChildren()
  },
  methods: {
    bindCheck() {
      this.$parent && this.$parent.updateCheck(this.value)
    }
  }
}
</script>
<style lang="scss" scoped>
.radio-item {
  width: 100%;
  font-size: 13px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: rgba(39, 36, 60, 0.5);
  line-height: 22px;
  box-sizing: border-box;
  margin-bottom: 10px;
  overflow: hidden;
}
.radio-item-active {
  color: #ffffff;
}
</style>
